//@flow
import moment from "moment"
import type { Kiosk, KioskInput } from "./types"
import { CONFIRMATION_MESSAGE } from "./constants"

export const makeWebDate = (time: string): string =>
  moment.utc(time).format("YYYY-MM-DD")

export const mapKioskDates = (kiosk: Kiosk): Kiosk =>
  typeof kiosk === "undefined"
    ? kiosk
    : {
        ...kiosk,
        startsAt: makeWebDate(kiosk.startsAt),
        endsAt: makeWebDate(kiosk.endsAt)
      }

export const createKioskInput = (kiosk: Kiosk): KioskInput => {
  const {
    primarySensor,
    id,
    usesVirtualKeyboard,
    __typename,
    ...result
  } = kiosk
  return {
    ...result,
    usesVirtualKeyboard: usesVirtualKeyboard || false,
    primarySensorId: primarySensor ? primarySensor.id : ""
  }
}

export const confirmDeletePath = (id: string): Object => ({
  pathname: `/admin/kiosks/${id}/confirm/delete`,
  state: {
    modal: true,
    successPath: "/admin/kiosks/",
    message: CONFIRMATION_MESSAGE
  }
})



// WEBPACK FOOTER //
// ./src/Kiosks/helpers.js